// extracted by mini-css-extract-plugin
export default {"tabButton":"styles_tabButton__8dm+Y","tabInfoWrapper":"styles_tabInfoWrapper__oZZ9u","tabInfo":"styles_tabInfo__FvTUN","tabContentWrapper":"styles_tabContentWrapper__wdJ9t"};